interface ShowProps {
  children: JSX.Element;
  when: boolean;
  fallback?: JSX.Element | null;
}

export const Show = ({ children, when, fallback = null }: ShowProps) => (when ? children : fallback);
